import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import dt from '../../../shared/theme';
import StockCodeFollowButton from '../../stock-codes/stock-code-follow-button';

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;

  .loading-panel {
    margin: -5px 0 0 20px;

    button {
      height: 26px;
      width: 100px;
      padding: 3px 0 3px 3px;

      .icon-lw {
        font-size: 14px;
        padding: 3px;
        line-height: 14px;
      }

      span {
        line-height: 20px;
      }
    }
  }
`;

const StockCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const CompanyName = styled.div`
  font-size: medium;
  color: ${props => dt(props).theme.bodyColor};
  white-space: nowrap;
  line-height: 18px;
`;

const StockExchange = styled.div`
  font-size: small;
  color: ${props => dt(props).theme.secondaryColor};
  line-height: 14px;
`;

const CountryFlag = styled.div`
  display: flex;
  margin-left: 20px;
  align-items: center;

  .icon {
    max-width: 40px;
  }
`;

export default function Tooltip({ tooltipId, stockCode }) {
  const country = { asx: 'au', nasdaq: 'us' }[_.toLower(stockCode.stockExchange)];

  return (
    <ReactTooltip
      id={tooltipId}
      type="light"
      effect="solid"
      delayHide={500}
      clickable
      className="stock-code-tooltip-container"
    >
      <TooltipContainer>
        <StockCodeContainer>
          <StockExchange>{stockCode.stockExchange}</StockExchange>
          <CompanyName>{stockCode.companyName}</CompanyName>
        </StockCodeContainer>
        {!!country && (
          <CountryFlag>
            <svg className="icon"><use href={`#${country}-flag`} /></svg>
          </CountryFlag>
        )}
        <StockCodeFollowButton stockCode={{ ...stockCode, slug: stockCode.slug }} />
      </TooltipContainer>
    </ReactTooltip>
  );
}

Tooltip.propTypes = {
  tooltipId: PropTypes.string.isRequired,
  stockCode: PropTypes.shape({
    id: PropTypes.number,
    stockExchange: PropTypes.string,
    code: PropTypes.string,
    slug: PropTypes.string,
    companyName: PropTypes.string,
    isStockCodeFollowedByCurrentUser: PropTypes.bool.isRequired,
  }).isRequired,
};
